console.log('customise code running')
const addToCartBtn = document.querySelector('.product-form__submit');
const uploadInput = document.querySelector("#image-upload");
function checkImageUpload() {
    let imageFound = false;
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key.includes("_croppedData")) {
            const data = localStorage.getItem(key);
            try {
                const parsed = JSON.parse(data);
                if (parsed?.value?.originalImage) {
                    imageFound = true;
                    break;
                }
            } catch (e) {}
        }
    }
    if (imageFound) {
        addToCartBtn.disabled = false;
        addToCartBtn.style.opacity = "1";
        addToCartBtn.style.cursor = "pointer";
        clearInterval(checkInterval);
    } else {
        addToCartBtn.disabled = true;
        addToCartBtn.style.opacity = "0.5";
        addToCartBtn.style.cursor = "not-allowed";
    }
}
checkImageUpload();
let checkInterval = setInterval(checkImageUpload, 500);
if (uploadInput) {
    uploadInput.addEventListener("change", function () {
        setTimeout(checkImageUpload, 2000);
    });
}
const form = document.querySelector('form[action="/cart/add"]');
if (form) {
    form.addEventListener("submit", function (e) {
        if (addToCartBtn.disabled) {
            e.preventDefault();
            e.stopImmediatePropagation();
            alert("Please upload an image before adding to cart.");
            return false;
        }
    }, true);
}
